import { examsNameMapExperiments } from '@/apps/experiments/experimentsMap.js'
import { availableActivities } from '@/util/config'

const examsNameMap = {
  EXAM_FLANKER: 'flanker',
  EXAM_GO_NO_GO: 'go-no-go',
  EXAM_TRAILS: 'trails',
  EXAM_PAIRED_ASSOCIATION: 'paired-association',
  EXAM_PROCESSING_SPEED: 'processing-speed',
  EXAM_IMPRINT_MEMORY_ASSESSMENT: 'image-pairs',
  ...examsNameMapExperiments
}

const examNameEntries = Object.entries(examsNameMap)

/**
 * @param examType
 */
export function getExamName(examType) {
  return examsNameMap[examType]
}

/**
 * @param examType
 */
export function getExamCode(examType) {
  const task = availableActivities.find(
    activity => activity.data_properties_values.exam_type === examType
  )
  return task.data_properties_values.exam_code
}

/**
 * @param examType
 */
export function getExamStoreName(examType) {
  const name = getExamName(examType)
  return name.replace(/-/g, '_')
}

/**
 * @param name
 */
export function getExamType(name) {
  // eslint-disable-next-line no-unused-vars
  const result = examNameEntries.find(([k, v]) => v === name)
  return result?.[0]
}

/**
 * @param obj
 */
export function removeEmptyThings(obj) {
  if (!obj) {
    return {}
  }
  const reduced = Object.entries(obj)?.reduce((acc, [k, v]) => {
    if (v && Object.entries(v).length > 0) {
      acc[k] = v
    }
    return acc
  }, {})

  return reduced
}
